import { render, staticRenderFns } from "./ConfigFlows.vue?vue&type=template&id=2925da72&scoped=true&"
import script from "./ConfigFlows.vue?vue&type=script&lang=js&"
export * from "./ConfigFlows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2925da72",
  null
  
)

export default component.exports